import store from '../store'

// Oturum kontrolü (eski main.js router.beforeEach'i, vue-router 4 dönüş sözleşmesiyle).
export function setupRouterGuards(router) {
  router.beforeEach((to) => {
    if (store.getters['Auth/isLoggedIn'] || to.name == "auth.sign-in-sso" || to.name == "joinToMeeting") {
      return true
    } else if (to.path === '/auth/sign-in') {
      return true
    } else {
      return '/auth/sign-in'
    }
  })
}
